var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDownGreen20X20({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.77 7.5 3.234 3.233L13.238 7.5a.83.83 0 1 1 1.175 1.175L10.587 12.5a.83.83 0 0 1-1.175 0L5.587 8.675a.83.83 0 0 1 0-1.175.848.848 0 0 1 1.183 0z",
    fill: "#22493B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDownGreen20X20);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down_green_20x20.0eff971ee01c5888ab611ff5a0f272c3.svg";
export { ForwardRef as ReactComponent };